import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import {
  getMiniIfaV2Async,
  getPreviewMiniIFABomAsync,
} from 'src/services/costModelling/shouldCostLibrary.services'

const initialState = {
  topDownApproachLoader: false,
  topDownApproachData: null,
  editedTopDownApproachData: null,
  isProceed: false,
  isSaved: false,
  isView: false,
  isEdit: false,
  isPreview: false,
  isDraft: false,
  prevBreakDownData: {
    exWorks: {
      raw_material: {
        component_percentage: '0',
        component_details: '',
        sub_components: [],
        component_name: 'Raw Material',
        isShowDetails: false,
      },
      packaging: {
        component_percentage: '0',
        component_details: '',
        sub_components: [],
        component_name: 'Packaging',
        isShowDetails: false,
      },
      labor: {
        component_percentage: '0',
        component_details: '',
        sub_components: [],
        component_name: 'Labor',
        isShowDetails: false,
      },
      conversion: {
        component_percentage: '0',
        component_details: '',
        sub_components: [],
        component_name: 'Conversion',
        isShowDetails: false,
      },
      overhead_margin: {
        component_percentage: '0',
        component_details: '',
        sub_components: [],
        component_name: 'Overhead & Margin',
        isShowDetails: false,
      },
    },
    fob: {
      origin_logistics: {
        component_percentage: '0',
        component_details: '',
        component_name: 'Origin Logistics',
        sub_components: [
          {
            subcomponent_name: '',
            subcomponent_details: '',
            subcomponent_percentage: '0',
            subcomponent_index_ticker: '',
            description: '',
            subcomponent_type: 'fob',
          },
        ],
        isShowDetails: false,
      },
    },
    landed: {
      other_logistics: {
        component_percentage: '0',
        component_details: '',
        sub_components: [
          {
            subcomponent_name: 'Aggregate Percentage',
            subcomponent_details: '',
            subcomponent_percentage: '0',
            subcomponent_index_ticker: '',
            description: '',
            subcomponent_type: 'landed',
          },
        ],
        component_name: 'Other Logistics',
        isShowDetails: false,
      },
      duty_and_tariff: {
        component_percentage: '0',
        component_details: '',
        sub_components: [
          {
            subcomponent_name: 'Duty',
            subcomponent_details: '',
            subcomponent_percentage: '0',
            subcomponent_index_ticker: '',
            description: '',
            subcomponent_type: 'landed',
          },
          {
            subcomponent_name: 'Tariff',
            subcomponent_details: '',
            subcomponent_percentage: '0',
            subcomponent_index_ticker: '',
            description: '',
            subcomponent_type: 'landed',
          },
        ],
        component_name: 'Duty and Tariff',
        isShowDetails: false,
      },
    },
  },
  previewLoader: false,
  modelDetailsData: {},
  viewLoader: false,
  viewModelDetailsData: {},
  isNewStatus: { isNewTopDown: false, isTopDown: false },
  approachType: '',
  isSpecificationAutoFetch: false,
}

export const topDownApproachSlice = createSlice({
  name: 'top-down-approach',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getPreviewMiniIFABomAsync.pending), (state) => {
      state.previewLoader = true
    })
    builder.addMatcher(isAnyOf(getPreviewMiniIFABomAsync.fulfilled), (state, action) => {
      state.previewLoader = false
      state.modelDetailsData = { ...state.modelDetailsData, ...action.payload.data }
    })
    builder.addMatcher(isAnyOf(getPreviewMiniIFABomAsync.rejected), (state, action) => {
      state.previewLoader = false
    })
    builder.addMatcher(isAnyOf(getMiniIfaV2Async.pending), (state) => {
      state.viewLoader = true
    })
    builder.addMatcher(isAnyOf(getMiniIfaV2Async.fulfilled), (state, action) => {
      state.viewLoader = false
      state.viewModelDetailsData = { ...state.modelDetailsData, ...action.payload.data }
    })
    builder.addMatcher(isAnyOf(getMiniIfaV2Async.rejected), (state, action) => {
      state.viewLoader = false
    })
  },

  reducers: {
    resetTopDownApproachSlice: (_, action) => {
      return action.payload ? { ...initialState, ...action.payload } : initialState
    },
    setTopDownApproachData: (state, action) => {
      state.topDownApproachData = structuredClone(action.payload)
    },
    setEditedTopDownApproachData: (state, action) => {
      state.editedTopDownApproachData = structuredClone(action.payload)
    },
    setProceedStatus: (state, action) => {
      state.isProceed = action.payload
    },
    setSaveStatus: (state, action) => {
      state.isSaved = action.payload
    },
    setIsView: (state, action) => {
      state.isView = action.payload
    },
    setIsEdit: (state, action) => {
      state.isEdit = action.payload
    },
    setIsDraft: (state, action) => {
      state.isDraft = action.payload
    },
    setIsPreview: (state, action) => {
      state.isPreview = action.payload
    },
    setPrevBreakDownData: (state, action) => {
      state.prevBreakDownData = action.payload
    },
    setIsNewStatus: (state, action) => {
      state.isNewStatus = structuredClone(action.payload)
    },
    setApproachType: (state, action) => {
      state.approachType = action.payload
    },
    setIsSpecificationAutoFetch: (state, action) => {
      state.isSpecificationAutoFetch = action.payload
    },
  },
})
export const {
  resetTopDownApproachSlice,
  setTopDownApproachData,
  setProceedStatus,
  setSaveStatus,
  setIsView,
  setIsPreview,
  setIsEdit,
  setIsDraft,
  setPrevBreakDownData,
  setIsNewStatus,
  setApproachType,
  setEditedTopDownApproachData,
  setIsSpecificationAutoFetch,
} = topDownApproachSlice.actions
export default topDownApproachSlice.reducer
